import { useTheme } from "@mui/material";
import { PrivyProvider } from "@privy-io/react-auth";

import { getEnvDependentChain, getExtraEnvChains } from "src/chains";

const LOGIN_METHODS = (
    import.meta.env.VITE_ENABLED_LOGIN_METHODS ?? "twitter,farcaster"
)
    .split(",")
    .filter(Boolean);

const WalletAuthProvider = ({ children }) => {
    const theme = useTheme();
    return (
        <PrivyProvider
            appId={import.meta.env.VITE_PUBLIC_PRIVY_APP_ID}
            config={{
                loginMethods: LOGIN_METHODS,
                defaultChain: getEnvDependentChain(),
                appearance: {
                    theme: "dark",
                    showWalletLoginFirst: false,
                    accentColor: theme.palette.primary.light,
                },
                embeddedWallets: {
                    ethereum: {
                        createOnLogin: "users-without-wallets",
                    },
                    showWalletUIs: false,
                },
                supportedChains: getExtraEnvChains(),
            }}
        >
            {children}
        </PrivyProvider>
    );
};

export default WalletAuthProvider;
